/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { isEmpty } from '@js/utility/global';

class HeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNavCollapsed: true,
      isToggled: 0,
    };
  }

  componentDidMount() {
    const { getIndexMiniCart } = this.props;

    getIndexMiniCart();
  }

  handleNavCollapse = () => {
    const { isNavCollapsed } = this.state;
    const el = document.querySelector('body');

    if (isNavCollapsed) {
      el.style.overflow = 'hidden';
    } else {
      el.style.overflow = null;
    }

    this.setState({ isNavCollapsed: !isNavCollapsed });
  };

  /**
   * Handle toggled dropdown.
   * @param {number} dropdown - dropdown number.
   */
  handleToggled = (dropdown, event) => {
    if (event.target.classList.contains('dropdown-icon')) {
      event.preventDefault();
    }

    const { isToggled } = this.state;
    if (isToggled === dropdown) {
      this.setState({ isToggled: 0 });
    } else {
      this.setState({ isToggled: dropdown });
    }
  };

  render() {
    const { miniCartData } = this.props;
    const { isNavCollapsed, isToggled } = this.state;

    return (
      // eslint-disable-next-line react/jsx-filename-extension
      <>
        {/* <Logo /> */}
        <header className={isNavCollapsed ? '' : 'position-fixed'}>
          <nav className="bg-secondary shadow-sm" id="main-nav">
            <div className="d-flex justify-content-between container header__container">
              <div className="d-flex justify-content-start align-items-lg-end">
                {/* logo */}
                <a
                  href="/"
                  className="align-items-lg-end pe-4 header__logo"
                  style={{
                    height: 65,
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="215.413"
                    height="65.027"
                    viewBox="0 0 215.413 65.027"
                  >
                    <g transform="translate(-1265.915 -844.592)">
                      <path
                        d="M80.23,61.827H75.915V0l3.672,3.607c.328.323,33.658,32.231,106.694,30.607h.057c7.547,0,71.583-.875,101.318-30.191L291.328.4V45.01h-4.315V10.448c-32.179,27.228-93.2,28.083-100.622,28.083h-.064C124.406,39.909,90.812,18.2,80.23,9.842Z"
                        transform="translate(1190 844.591)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M235.238,84.75v-.933l5.993-7.412h-5.757v-.881h7.206v.829l-6.044,7.515h6.044v.881Z"
                        transform="translate(1142.216 821.94)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M254.707,84.75V80.81c0-1.114-.774-1.684-2.02-1.684s-2.071.583-2.071,1.684V84.75H249.4V75.524h1.212v3.55a3.414,3.414,0,0,1,2.324-.777c1.869,0,2.979.92,2.979,2.358V84.75Z"
                        transform="translate(1137.968 821.94)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M263.485,83c0,1.4.858,2.2,2.441,2.2a3.143,3.143,0,0,0,2.172-.726l.825.557a4.39,4.39,0,0,1-3.03.985c-2.19,0-3.621-1.011-3.621-3.266a3.069,3.069,0,0,1,3.4-3.265c2.139,0,3.4,1.192,3.4,3.084V83Zm4.126-1.762a2.19,2.19,0,0,0-4.126,1.063h4.378a2.171,2.171,0,0,0-.252-1.063"
                        transform="translate(1134.108 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M280.973,85.938V82.012c0-1.127-.791-1.7-2.037-1.7s-2.055.583-2.055,1.7v3.926H275.67V79.563h1.212v.7a3.959,3.959,0,0,1,4.445-.181,2.086,2.086,0,0,1,.858,1.775v4.081Z"
                        transform="translate(1130.09 820.752)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M291.66,88.866a4.289,4.289,0,0,1-2.811-.856l.791-.6a2.963,2.963,0,0,0,1.987.635c1.6,0,2.272-.868,2.272-1.957v-1a3.048,3.048,0,0,1-2.324.829,3.373,3.373,0,0,1-2-.57,4,4,0,0,1,0-5.313,3.431,3.431,0,0,1,2.02-.557,2.978,2.978,0,0,1,2.324.83v-.752h1.2v6.57c0,1.58-1.279,2.734-3.451,2.734m.186-8.552c-1.8,0-2.071,1.192-2.071,2.384s.27,2.384,2.071,2.384S293.9,83.89,293.9,82.7s-.253-2.384-2.054-2.384"
                        transform="translate(1126.223 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M307.551,84.75V80.81c0-1.114-.774-1.684-2.02-1.684s-2.071.583-2.071,1.684V84.75h-1.212V75.524h1.212v3.55a3.414,3.414,0,0,1,2.324-.777c1.868,0,2.979.92,2.979,2.358V84.75Z"
                        transform="translate(1122.119 821.94)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M316.328,83c0,1.4.859,2.2,2.442,2.2a3.14,3.14,0,0,0,2.172-.726l.825.557a4.388,4.388,0,0,1-3.03.985c-2.189,0-3.62-1.011-3.62-3.266a3.069,3.069,0,0,1,3.4-3.265c2.138,0,3.4,1.192,3.4,3.084V83Zm4.126-1.762a2.19,2.19,0,0,0-4.126,1.063h4.378a2.156,2.156,0,0,0-.252-1.063"
                        transform="translate(1118.26 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M336.1,76.4v3.4h5.253v.881H336.1V84.75h-1.28V75.524h7.442V76.4Z"
                        transform="translate(1112.352 821.94)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M352.672,85.289a4.244,4.244,0,0,1-4.748,0,3.7,3.7,0,0,1,0-5.079,4.244,4.244,0,0,1,4.748,0,3.7,3.7,0,0,1,0,5.079m-.859-4.509a2.489,2.489,0,0,0-1.515-.466,2.441,2.441,0,0,0-1.5.466,3.217,3.217,0,0,0,0,3.939,2.441,2.441,0,0,0,1.5.466,2.49,2.49,0,0,0,1.515-.466,3.285,3.285,0,0,0,0-3.939"
                        transform="translate(1108.723 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M365.42,85.289a4.244,4.244,0,0,1-4.748,0,3.7,3.7,0,0,1,0-5.079,4.244,4.244,0,0,1,4.748,0,3.7,3.7,0,0,1,0,5.079m-.859-4.509a2.49,2.49,0,0,0-1.515-.466,2.44,2.44,0,0,0-1.5.466,3.217,3.217,0,0,0,0,3.939,2.441,2.441,0,0,0,1.5.466,2.49,2.49,0,0,0,1.515-.466,3.285,3.285,0,0,0,0-3.939"
                        transform="translate(1104.9 820.753)"
                        fill="#2e3a47"
                      />
                      <path
                        d="M377.8,84.749v-.764a3.06,3.06,0,0,1-2.357.842,3.431,3.431,0,0,1-2.02-.557,4.135,4.135,0,0,1,0-5.417,3.431,3.431,0,0,1,2.02-.557,3.051,3.051,0,0,1,2.34.817v-3.59h1.213v9.226Zm-2.088-5.624c-1.8,0-2.087,1.192-2.087,2.436S373.909,84,375.71,84s2.071-1.192,2.071-2.436-.27-2.436-2.071-2.436"
                        transform="translate(1101.076 821.941)"
                        fill="#2e3a47"
                      />
                    </g>
                  </svg>
                </a>
              </div>
              <div className="d-flex align-items-center align-items-lg-end">
                {/* user */}
                <a href="/my-account/index" className="align-items-center align-items-lg-end pe-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.381"
                    height="35.381"
                    viewBox="0 0 35.381 35.381"
                  >
                    <path
                      d="M510.991,395.812a17.69,17.69,0,1,0,17.691,17.69,17.69,17.69,0,0,0-17.691-17.69m0,4.315a5.039,5.039,0,1,1-5.039,5.039,5.039,5.039,0,0,1,5.039-5.039m6.9,23.6H504.1a2.454,2.454,0,0,1-2.454-2.453,9.349,9.349,0,1,1,18.7,0,2.453,2.453,0,0,1-2.453,2.453"
                      transform="translate(-493.301 -395.812)"
                      fill="#fff"
                    />
                  </svg>
                </a>
                {/* cart */}
                <a
                  href="/cart"
                  className="align-items-center align-items-lg-end pe-2 nav-top__icon"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.381"
                    height="35.381"
                    viewBox="0 0 35.381 35.381"
                  >
                    <path
                      d="M192.13,174.707a17.69,17.69,0,1,0,17.691,17.69,17.69,17.69,0,0,0-17.691-17.69m-2.01,27.806a1.512,1.512,0,0,1-.1.311,1.326,1.326,0,0,1-.151.28,1.568,1.568,0,0,1-.2.251,1.59,1.59,0,0,1-.25.207,1.768,1.768,0,0,1-.285.151,1.493,1.493,0,0,1-.311.1,1.55,1.55,0,0,1-.32.031,1.648,1.648,0,0,1-1.166-.484,1.42,1.42,0,0,1-.2-.251,1.373,1.373,0,0,1-.151-.28,1.728,1.728,0,0,1-.13-.631,1.622,1.622,0,0,1,.035-.324,1.593,1.593,0,0,1,.1-.306,1.527,1.527,0,0,1,.151-.285,1.458,1.458,0,0,1,.2-.251,1.6,1.6,0,0,1,.251-.207,2.211,2.211,0,0,1,.285-.151,1.532,1.532,0,0,1,.306-.091,1.653,1.653,0,0,1,1.49.449,1.614,1.614,0,0,1,.2.251,1.47,1.47,0,0,1,.151.285,1.525,1.525,0,0,1,.1.306,1.616,1.616,0,0,1,.031.324,1.577,1.577,0,0,1-.031.32m8.974,0a1.888,1.888,0,0,1-.091.311,1.617,1.617,0,0,1-.155.28,1.227,1.227,0,0,1-.2.251,1.646,1.646,0,0,1-2.332,0,1.568,1.568,0,0,1-.2-.251,1.326,1.326,0,0,1-.151-.28,1.512,1.512,0,0,1-.1-.311,1.577,1.577,0,0,1-.031-.32,1.616,1.616,0,0,1,.031-.324,1.525,1.525,0,0,1,.1-.306,1.47,1.47,0,0,1,.151-.285,1.614,1.614,0,0,1,.2-.251,1.653,1.653,0,0,1,1.49-.449,1.513,1.513,0,0,1,.306.091,2.147,2.147,0,0,1,.285.151,1.6,1.6,0,0,1,.251.207,1.255,1.255,0,0,1,.2.251,1.828,1.828,0,0,1,.155.285,1.919,1.919,0,0,1,.091.306,1.622,1.622,0,0,1,.035.324,1.583,1.583,0,0,1-.035.32m2.53-15.444-1.992,8.361a.68.68,0,0,1-.662.522H187.879l.409,1.715H198.97a.68.68,0,0,1,0,1.361H187.75a.674.674,0,0,1-.2-.035l-.032-.01a.671.671,0,0,1-.171-.092l-.026-.022a.678.678,0,0,1-.136-.147l-.007-.013a.7.7,0,0,1-.081-.19l-.006-.014-.732-3.074h0l-1.992-8.361v-.005l-.607-2.548h-3.307a.681.681,0,0,1,0-1.361h3.844a.681.681,0,0,1,.662.523l.608,2.553h15.4a.681.681,0,0,1,.662.838"
                      transform="translate(-174.44 -174.707)"
                      fill="#fff"
                    />
                  </svg>
                  {isEmpty(miniCartData) || !miniCartData.hasOwnProperty('Count') ? (
                    <span className="nav-top__badge">0</span>
                  ) : (
                    <span className="nav-top__badge">{miniCartData.Count}</span>
                  )}
                </a>
                {/* search input */}
                <form className="d-none d-lg-block pe-2" id="search-form">
                  <input
                    className="form-control rounded-pill"
                    placeholder="Search..."
                    style={{ display: 'none' }}
                  />
                </form>
                {/* search */}
                <a href="#" style={{ display: 'none' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="35.3"
                    height="35.298"
                    viewBox="0 0 35.3 35.298"
                  >
                    <g transform="translate(-1811.675 -1091.937)">
                      <path
                        d="M370.326,292.346A17.649,17.649,0,1,0,387.975,310a17.65,17.65,0,0,0-17.649-17.649m10.54,28.66a1.122,1.122,0,0,1-1.585-.085L373.958,315a8.437,8.437,0,0,1-4.3,1.459,8.891,8.891,0,0,1-.935,0,8.478,8.478,0,1,1,6.9-2.959l5.322,5.924a1.122,1.122,0,0,1-.085,1.585"
                        transform="translate(1459 799.591)"
                        fill="#fff"
                      />
                      <path
                        d="M370.353,300.113a6.6,6.6,0,0,0-4.589-2.2,6.8,6.8,0,0,0-.739,0,6.65,6.65,0,1,0,5.328,2.2"
                        transform="translate(1462.793 803.057)"
                        fill="#fff"
                      />
                    </g>
                  </svg>
                </a>
                {/* mobile menu */}
                <button
                  className="navbar-toggler d-lg-none"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded={!isNavCollapsed}
                  onClick={this.handleNavCollapse}
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon navbar__toggler-icon" />
                </button>
              </div>
            </div>
          </nav>
          <nav
            className={
              isNavCollapsed
                ? 'navbar navbar-expand-lg navbar__nav-header justify-content-between align-items-start align-items-lg-center py-0'
                : 'navbar__nav-header-expanded navbar navbar-expand-lg navbar__nav-header justify-content-between align-items-start align-items-lg-center py-0'
            }
          >
            <div className="container d-lg-flex">
              <a className="navbar-brand navbar__brand-header d-none d-lg-block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="159"
                  height="18"
                  viewBox="0 0 159 18"
                >
                  <path
                    d="M548.2,131.113l.34-.661c1.617.359,3.781.944,5.92,1.6a15.453,15.453,0,0,0,2.609-2.151H546.2v3.7c1.773-.133,3.468-.3,4.981-.51l.209.641a60.154,60.154,0,0,1-10.537,2.019l-.782-1.868c1.252-.019,2.53-.057,3.834-.132v-9.433h6.78c-.886-.869-1.982-1.868-2.737-2.548a35.276,35.276,0,0,1-9.338,3.869l-.443-.643c4.121-1.32,9.311-4.546,10.928-7l2.816.679a10.169,10.169,0,0,1-.756.774A32.787,32.787,0,0,0,562,123.414l-1.486,1.831a29.088,29.088,0,0,1-10.042-5.207c-.547.415-1.121.849-1.747,1.246a22.4,22.4,0,0,1,4.068,2.13l-1.3.907h5.687v5.471l.182-.189,2.216,1.151a20.56,20.56,0,0,1-3.756,1.716c2.112.679,4.068,1.358,5.346,1.869L559.522,136A91.567,91.567,0,0,0,548.2,131.113Zm-2.008-2.056h8.737v-1.622H546.2Zm0-2.378h8.737V125.17H546.2Zm-47.853,9.17v-8.51a17.852,17.852,0,0,1-4.93,5.056l-.652-.452a18.957,18.957,0,0,0,5.007-7.49h-4.46V123.6h5.035v-2.9c-1.565.189-3.1.339-4.486.452l-.209-.661a39.408,39.408,0,0,0,9.154-2.414l2.244,1.433a38.591,38.591,0,0,1-4.408.868V123.6H505.7v.849h-5.059v.605a20.541,20.541,0,0,1,4.459,3.3l-2.008,1.076c-.6-.925-1.59-2.208-2.451-3.264v9.679Zm-44.62-.113v-8.056a20.017,20.017,0,0,1-5.267,5.283l-.679-.492a21.719,21.719,0,0,0,5.425-7.924h-4.46V123.7h4.982v-3.075c-1.669.207-3.286.358-4.747.434l-.182-.661a29.6,29.6,0,0,0,9.155-2.377l1.982,1.472c-1.252.321-2.556.586-3.86.791V123.7h4.225v.849h-4.225v1.34a21.639,21.639,0,0,1,4.46,2.9l-1.956,1.171c-.807-1.039-1.747-2.094-2.5-2.906v8.679Zm59.251-3a61.568,61.568,0,0,1-10.485,2.245l-.756-1.961c.756-.019,1.459-.056,2.138-.094a44.953,44.953,0,0,0,4.3-14.112l2.842.377c-1.2,4.809-3.626,10.6-5.842,13.659a72.169,72.169,0,0,0,7.407-.886,36.93,36.93,0,0,0-1.9-3.245l.835-.34a31.194,31.194,0,0,1,5.294,6.527l-2.581.811A28.341,28.341,0,0,0,512.973,132.735Zm-52.1,2.51V120.527h9.1v14.414h-2.349v-1.868h-4.51v2.171Zm2.244-3.018h4.51V121.378h-4.51ZM403,134.98v-1.037h3.912v-9.679h2.4v9.679h4.85v-13.32H404.3v-.943h20.525v.943h-8.163v5.754h7.094v.848h-7.094v6.717h9.128v1.037Z"
                    transform="translate(-403 -118)"
                    fill="#dbcfd1"
                  />
                </svg>
              </a>
              <div
                className={
                  isNavCollapsed
                    ? 'collapse navbar-collapse d-lg-flex justify-content-end'
                    : 'navbar-collapse d-lg-flex justify-content-end'
                }
                id="navbarNavDropdown"
              >
                <ul className="navbar-nav">
                  {/* 正和私食 */}
                  <li className="nav__item dropdown">
                    <a
                      className="nav-link nav__link nav__dropdown-menu-link"
                      href="javascript:void(0);"
                    >
                      正和私食
                      <span className="dropdown-icon" onClick={(e) => this.handleToggled(1, e)} />
                    </a>
                    <ul
                      className={
                        isToggled === 1
                          ? 'dropdown-menu nav__dropdown-menu nav__dropdown-menu-toggled'
                          : 'dropdown-menu nav__dropdown-menu'
                      }
                    >
                      <li className="dropdown-item nav__dropdown-item">
                        <a className="nav-link nav__link nav__dropdown-item-link" href="/">
                          品牌故事
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <a
                          className="nav-link nav__link nav__dropdown-item-link"
                          href="/my-account/onlineContactform"
                        >
                          聯絡我們
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <a
                          className="nav-link nav__link nav__dropdown-item-link"
                          // 正式網址
                          href="/event/zhfood/purchaseprocess"
                          // 測試網址
                          // href="/purchase-process"
                        >
                          購物流程
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <a
                          className="nav-link nav__link nav__dropdown-item-link"
                          // 正式網址
                          href="/event/zhfood/antifraud"
                          // 測試網址
                          // href="/anti-fraud"
                        >
                          防詐騙提醒
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/* 元鍋 JOHN's */}
                  <li className="nav__item dropdown">
                    <a
                      className="nav-link nav__link nav__dropdown-menu-link"
                      href="/johns"
                    >
                      元鍋 JOHN's
                      <span className="dropdown-icon" onClick={(e) => this.handleToggled(2, e)} />
                    </a>
                    <ul
                      className={
                        isToggled === 2 || (isToggled > 3 && isToggled < 6)
                          ? 'dropdown-menu nav__dropdown-menu nav__dropdown-menu-toggled'
                          : 'dropdown-menu nav__dropdown-menu'
                      }
                    >
                      <li className="dropdown-item nav__dropdown-item">
                        <a className="nav-link nav__link nav__dropdown-item-link" href="/johns">
                          JOHN's 故事
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item dropdown">
                        <div
                          role="button"
                          tabIndex="0"
                          className="nav-link nav__link nav__dropdown-menu-link"
                          onKeyDown={() => {}}
                        >
                          <a
                            className={
                              isNavCollapsed
                                ? 'nav__link-font-noline'
                                : 'nav__link-font-noline nav__link-font-white'
                            }
                            href="/johns-noodles"
                          >
                            醬的麵
                            <span className="dropdown-icon" onClick={(e) => this.handleToggled(4, e)} />
                          </a>
                        </div>
                        <ul
                          className={
                            isToggled === 4
                              ? 'dropdown-menu nav__dropdown-submenu nav__dropdown-menu-toggled'
                              : 'dropdown-menu nav__dropdown-submenu'
                          }
                        >
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054000986"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              美麗酸辣麵
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054000987"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              蔥油香拌麵
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001065"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              堅果擔擔麵
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054000988"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              台式炸醬麵
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001006"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              秘密牛肋麵
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001050"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              清燉半筋半肉牛肉麵
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001054"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              干貝雞湯麵
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <div
                          role="button"
                          tabIndex="0"
                          className="nav-link nav__link nav__dropdown-menu-link"
                          onKeyDown={() => {}}
                        >
                          <a
                            className={
                              isNavCollapsed
                                ? 'nav__link-font-noline'
                                : 'nav__link-font-noline nav__link-font-white'
                            }
                            href="/johns-sauce"
                          >
                            醬的醬
                            <span className="dropdown-icon" onClick={(e) => this.handleToggled(5, e)} />
                          </a>
                        </div>
                        <ul
                          className={
                            isToggled === 5
                              ? 'dropdown-menu nav__dropdown-submenu nav__dropdown-menu-toggled'
                              : 'dropdown-menu nav__dropdown-submenu'
                          }
                        >
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054000992"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              美麗醬
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001056"
                              // 測試連結
                              // href="/p/012345678"
                            >
                              干貝醬
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <a
                          className="nav-link nav__link nav__dropdown-item-link"
                          // 正式網址
                          href="/event/zhfood/john-stores"
                        >
                          醬在這
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <a
                          className="nav-link nav__link nav__dropdown-item-link"
                          // 正式網址
                          href="/event/zhfood/john-news"
                        >
                          醬報導
                        </a>
                      </li>
                    </ul>
                  </li>
                  {/* MMM by Paul Lee */}
                  <li className="nav__item dropdown">
                    <a
                      className="nav-link nav__link nav__dropdown-menu-link"
                      href="/mmm"
                    >
                      MMM by Paul Lee
                      <span className="dropdown-icon" onClick={(e) => this.handleToggled(3, e)} />
                    </a>
                    <ul
                      className={
                        isToggled === 3 || (isToggled > 5 && isToggled < 8)
                          ? 'dropdown-menu nav__dropdown-menu nav__dropdown-menu-toggled'
                          : 'dropdown-menu nav__dropdown-menu'
                      }
                    >
                      <li className="dropdown-item nav__dropdown-item">
                        <a className="nav-link nav__link nav__dropdown-item-link" href="/mmm">
                          關於 Paul Lee
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <div
                          role="button"
                          tabIndex="0"
                          className="nav-link nav__link nav__dropdown-menu-link"
                          onKeyDown={() => {}}
                        >
                          <a
                            className={
                              isNavCollapsed
                                ? 'nav__link-font-noline'
                                : 'nav__link-font-noline nav__link-font-white'
                            }
                            href="/mmm-sauce"
                          >
                            醬料 Sauce
                            <span className="dropdown-icon" onClick={(e) => this.handleToggled(6, e)} />
                          </a>
                        </div>
                        <ul
                          className={
                            isToggled === 6
                              ? 'dropdown-menu nav__dropdown-submenu nav__dropdown-menu-toggled'
                              : 'dropdown-menu nav__dropdown-submenu'
                          }
                        >
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001070"
                              // 測試連結
                              // href="/p/012345679"
                            >
                              經典義式番茄牛肉醬
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001071"
                              // 測試連結
                              // href="/p/012345679"
                            >
                              西班牙熟成火腿白醬
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <div
                          role="button"
                          tabIndex="0"
                          className="nav-link nav__link nav__dropdown-menu-link"
                          onKeyDown={() => {}}
                        >
                          <a
                            className={
                              isNavCollapsed
                                ? 'nav__link-font-noline'
                                : 'nav__link-font-noline nav__link-font-white'
                            }
                            href="/mmm-noodles"
                          >
                            麵食 Noodles
                            <span className="dropdown-icon" onClick={(e) => this.handleToggled(7, e)} />
                          </a>
                        </div>
                        <ul
                          className={
                            isToggled === 7
                              ? 'dropdown-menu nav__dropdown-submenu nav__dropdown-menu-toggled'
                              : 'dropdown-menu nav__dropdown-submenu'
                          }
                        >
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001067"
                              // 測試連結
                              // href="/p/012345679"
                            >
                              越南牛肉湯河粉
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001068"
                              // 測試連結
                              // href="/p/012345679"
                            >
                              蝦汁乾拌麵
                            </a>
                          </li>
                          <li className="dropdown-item nav__dropdown-item">
                            <a
                              className="nav-link nav__link nav__dropdown-item-link"
                              // 正式連結
                              href="/p/054001072"
                              // 測試連結
                              // href="/p/012345679"
                            >
                              MMM BY PAUL LEE 大世界小餐桌禮盒
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <a
                          className="nav-link nav__link nav__dropdown-item-link"
                          href="/mmm-videos"
                        >
                          主廚秘訣
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <a
                          className="nav-link nav__link nav__dropdown-item-link"
                          // 正式網址
                          href="/event/zhfood/mmm-stores"
                        >
                          銷售據點
                        </a>
                      </li>
                      <li className="dropdown-item nav__dropdown-item">
                        <a
                          className="nav-link nav__link nav__dropdown-item-link"
                          // 正式網址
                          href="/event/zhfood/mmm-news"
                        >
                          媒體報導
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>
      </>
    );
  }
}

export default HeaderContainer;
